import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "./ConfirmationModal";

const FullscreenModal = ({ show, onHide, title, children, footer, navigateOnClose = null, fullscreen = true, size = "lg", requireConfirmOnClose = true }) => {
	const navigate = useNavigate();
	const [showConfirm, setShowConfirm] = useState(false);

	const handleCloseAttempt = () => {
		if (!requireConfirmOnClose) {
			if (navigateOnClose) navigate(navigateOnClose);
			onHide();
			return;
		}
		setShowConfirm(true);
	};

	const handleConfirmClose = () => {
		setShowConfirm(false);
		if (navigateOnClose) {
			navigate(navigateOnClose);
		}
		onHide();
	};

	const handleCancelClose = () => {
		setShowConfirm(false);
	};

	return (
		<>
			<Modal
				show={show}
				onHide={handleCloseAttempt}
				size={fullscreen ? "xl" : size}
				centered={!fullscreen}
				backdrop="static"
				keyboard={true}
				dialogClassName={fullscreen ? "modal-fullscreen-lg-down vh-100" : ""}
				contentClassName={fullscreen ? "h-100 d-flex flex-column border-0" : "d-flex flex-column border-0"}
			>
				<Modal.Header closeButton className="border-0 ">
					<b className="px-5">{title}</b>
				</Modal.Header>

				<Modal.Body className="flex-grow-1 px-0 border-0 overflow-auto" style={{ maxHeight: fullscreen ? "calc(100vh - 180px)" : "80vh" }}>
					{children}
				</Modal.Body>

				{footer && <Modal.Footer className=" py-3">{footer}</Modal.Footer>}
			</Modal>
			<ConfirmationModal
				show={showConfirm}
				onConfirm={handleConfirmClose}
				onCancel={handleCancelClose}
				title="Confirm Close"
				message="Are you sure you want to close this modal?"
			/>
		</>
	);
};

export default FullscreenModal;
